import React, { Fragment, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import ReturnEdit from './ReturnEdit';
import {
    receive,
    receiveList,
    changeMode,
    receiveOrderArticles,
} from '../../ActionsBrafab/Returns.action';
import { ViewMode } from '../../constants';

const PendingReturnDetails = ({ showList, updateRow, updateRowClassification, submit, uploadImages, returnSchema }) => {
    const { pendingReturn, list, currentPage } = useSelector((state) => state.myPage.returns);
    const dispatch = useDispatch();
    const returnEditRef = useRef();
    const [returnRows, setReturnRows] = useState(pendingReturn.returnRows);
    const [hasChanged, setHasChanged] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const [returnCreated, setReturnCreated] = useState(null);
    const dialogRef = useRef(null);

    const onSubmit = async () => {
        const goOn = confirm(translate('code.mypage.returndetails.confirm.send'));
        if (goOn) {
            if (returnEditRef.current) {
                await returnEditRef.current.SaveAll();
            }

            setTimeout(() => {
                const errorArray = [];

                // Validate each return row
                const validationPromises = returnRows.map((returnObject, index) => {
                    return returnSchema.validate(returnObject, { abortEarly: false }).catch((error) => {
                        // save each error per row
                        error.inner.forEach((validationError) => {
                            const { path, message } = validationError;
                            if (!errorArray[index]) {
                                errorArray[index] = {};
                            }
                            if (!errorArray[index][path]) {
                                errorArray[index][path] = [];
                            }
                            errorArray[index][path].push(message);
                        });
                    });
                });

                Promise.all(validationPromises).then(() => {
                    if (errorArray.length > 0) {
                        setValidationErrors(errorArray);
                        setReturnCreated(null);
                        dialogRef.current.showModal();
                    } else {
                        submit(pendingReturn.id)
                            .then((response) => response.json())
                            .then((result) => {
                                setReturnCreated(result);
                                dialogRef.current.showModal();
                            })
                            .catch(() => {
                                setReturnCreated(null);
                                dialogRef.current.showModal();
                            });
                    }
                });
            }, 2000); 
        }
    };

    const onDialogClick = () => {
        dialogRef.current.close();
        if (returnCreated) {
            dispatch(receive({}));
            dispatch(receiveOrderArticles([]));

            //If return list is on page one, we must add it first in list
            if (currentPage == 1) {
                list.unshift(returnCreated);
                if (list.length > 15) {
                    list.pop();
                }
                dispatch(receiveList(list));
            }
            dispatch(changeMode(ViewMode.List));
        }
    };

    return (
        <Fragment>
            <div className="returns">
                <div className="returns__pending-panel">
                    {pendingReturn?.infoText && pendingReturn.infoText.length > 0 && (
                        <div
                            className="returns__pending-panel-info-header medium-8"
                            dangerouslySetInnerHTML={{ __html: pendingReturn.infoText }}
                        ></div>
                    )}

                    <div className="row">
                        <div className="small-6 columns">
                            <button className="button" onClick={showList}>
                                {translate('code.mypage.returndetails.button.back')}
                            </button>
                        </div>
                        <div className="small-6 columns text-right">
                            {pendingReturn && pendingReturn.returnRows && (
                                <button
                                    onClick={() => onSubmit()}
                                    className="button returns__pending-panel-pending-send"
                                >
                                    {translate('code.mypage.returndetails.button.send')}{' '}
                                    <i className="fa fa-paper-plane"></i>
                                </button>
                            )}
                        </div>
                    </div>
                    <h4>{translate('code.mypage.returndetails.title')}</h4>
                    {pendingReturn?.returnRows && pendingReturn.returnRows.length > 0 ? (
                        <Fragment>
                            <span>{translate('code.mypage.returndetails.subtitle')}</span>

                            <ReturnEdit
                                ref={returnEditRef}
                                isPending={true}
                                currentReturn={pendingReturn}
                                returnRows={returnRows}
                                setReturnRows={setReturnRows}
                                hasChanged={hasChanged}
                                setHasChanged={setHasChanged}
                                validationErrors={validationErrors}
                                uploadImages={uploadImages}
                                updateRow={updateRow}
                                updateRowClassification={updateRowClassification}
                            ></ReturnEdit>

                            <div className="row">
                                <div className="small-12 columns text-right">
                                    <button
                                        onClick={() => onSubmit()}
                                        className="button returns__pending-panel-pending-send bottom-button"
                                    >
                                        {translate('code.mypage.returndetails.button.send')}{' '}
                                        <i className="fas fa-paper-plane"></i>
                                    </button>
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <div>{translate('code.mypage.returndetails.info.nodata')}</div>
                    )}
                </div>
            </div>
            <dialog ref={dialogRef} className="returns__dialog">
                <button
                    className="checkout-reseller__termsdialog--close"
                    value="cancel"
                    onClick={() => dialogRef.current.close()}
                >
                    X
                </button>
                <h4>
                    {returnCreated
                        ? translate('code.mypage.returndetails.created.title')
                        : translate('code.mypage.returndetails.notcreated.title')}
                </h4>
                {returnCreated ? (
                    <span>
                        {translate('code.mypage.returndetails.created.message')} {returnCreated.id}.
                    </span>
                ) : (
                    <span>
                        {translate('code.mypage.returndetails.notcreated.message')}{' '}
                        <a
                            href={`mailto:${translate(
                                'code.mypage.returndetails.notcreated.message.mail'
                            )}`}
                        >
                            {translate('code.mypage.returndetails.notcreated.message.mail')}
                        </a>
                        .
                    </span>
                )}
                <button className="button returns__dialog--button" onClick={() => onDialogClick()}>
                    {translate('code.mypage.returndetails.message.ok')}
                </button>
            </dialog>
        </Fragment>
    );
};

export default PendingReturnDetails;
